(() => {
  const root = document.querySelector('[data-product-id][data-standard="Leotara Master Product Landing Page Gold Standard v3.0"]');
  if (!root) return;
  const productId = root.getAttribute('data-product-id');
  const forms = [...root.querySelectorAll('form[data-type="leotara-governed-paid-checkout"]')];
  if (!productId || !forms.length) return;
  let submitting = false;
  const fail = (form, label) => {
    submitting = false;
    const button = form.querySelector('button[type="submit"]');
    if (button) { button.disabled = false; button.textContent = label; }
    let status = form.querySelector('[data-commerce-status]');
    if (!status) { status = document.createElement('p'); status.setAttribute('data-commerce-status', ''); status.setAttribute('role', 'alert'); form.append(status); }
    status.textContent = 'Secure checkout could not be prepared. Your cart was not submitted. Please try again.';
  };
  forms.forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting) return;
    submitting = true;
    const button = form.querySelector('button[type="submit"]');
    const label = button ? button.textContent : 'Buy System';
    if (button) { button.disabled = true; button.textContent = 'Preparing secure checkout…'; }
    try {
      const initiated = await fetch('https://vault.leotara.com/api/v2/commerce/shopify-initiate', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({productId})});
      if (!initiated.ok) throw new Error('initiation_failed');
      const initiation = await initiated.json();
      if (!initiation.ok || !initiation.checkoutUrl || !/^https:\/\/(leotara\.com|wjtw6b-re\.myshopify\.com)\/cart\/c\//.test(initiation.checkoutUrl)) throw new Error('fresh_cart_missing');
      if (initiation.bindingStatus !== 'BOUND' && initiation.bindingStatus !== 'ALREADY_BOUND_SAME_TOKEN') throw new Error('binding_missing');
      window.location.assign(initiation.checkoutUrl);
    } catch { fail(form, label); }
  }, true));
})();
